import { RouteRecordRaw } from 'vue-router';

import { ROUTE_NAMES } from '@/constants';
import i18n, { loadTranslations } from '@/plugins/i18n';

import { authenticationGuard, fetchCommonData } from './guards';

const Cart = () => import('@/pages/Cart/Cart.vue');
const CartConfirm = () => import('@/pages/Cart/components/CartConfirm.vue');

const fetchTranslations = async (_to, _from) => {
  await Promise.all([
    loadTranslations('shop'),
    loadTranslations('cart'),
    loadTranslations('orders'),
    loadTranslations('productRecommendation'),
  ]);
};

const cartRoutes: RouteRecordRaw[] = [
  {
    path: '/cart/',
    name: ROUTE_NAMES.CART,
    component: Cart,
    beforeEnter: [authenticationGuard, fetchCommonData, fetchTranslations],
    meta: {
      title: i18n.t('cart.title'),
    },
  },
  {
    path: '/cart/review/',
    name: ROUTE_NAMES.CART_ORDER_REVIEW,
    component: CartConfirm,
    beforeEnter: [authenticationGuard, fetchCommonData, fetchTranslations],
    meta: {
      title: i18n.t('cart.confirm.title'),
    },
  },
];

export default cartRoutes;
